module.exports = __webpack_public_path__ + "static/media/CornerUpRight.19b115dd.svg";